import { sdgTargetResultSchema } from "@/schema/console/evaluation-reports/SdgTargetResult";
import { z } from "zod";

export const sdgGoalResultSchema = z.object({
  id: z.number(),
  sdg_goal_id: z.number(),
  name: z.string(),
  score: z.number().nullable(),
  sdg_target_results: z.array(sdgTargetResultSchema),
});

export type SdgGoalResult = z.infer<typeof sdgGoalResultSchema>;
